import React, { FC, useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { SUPPLIER_PROD_REPORT_ID, SUPPLIER_STAGE_REPORT_ID } from "@constants";
import { PbiReport } from "@components/common";
import { StyledCard } from "@components/common/CardTable/CardTable.styled";
import { Box, Stack } from "@components/base";
import { getWindowSize, isProduction } from "@helpers";

interface Dashboard {}

const Dashboard: FC<Dashboard> = () => {
  const { t } = useTranslation();
  const [windowSize, setWindowSize] = useState(getWindowSize());

  useEffect(() => {
    const handleWindowResize = (): void => {
      setWindowSize(getWindowSize());
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  return (
    <StyledCard>
      <Stack spacing={2} direction="row" justifyContent="space-between" p={3}>
        <Typography variant="subtitle1">{t("common.dashboard")}</Typography>
      </Stack>
      <Box sx={{ height: windowSize.innerWidth * 0.28, overflow: "hidden" }}>
        <PbiReport
          bg={"default"}
          height={windowSize.innerWidth * 0.3}
          reportId={
            isProduction() ? SUPPLIER_PROD_REPORT_ID : SUPPLIER_STAGE_REPORT_ID
          }
          pageId={"6b5bee137b1fb6ba291d"}
        />
      </Box>
    </StyledCard>
  );
};

export default Dashboard;
